export default "__VITE_ASSET__BbPSWrmT__"